// Mirrors backend/utils/pdfTemplates.js. Documents still carry a plain
// pdf_template_id with no templates table behind it, so this is the list the
// account settings offer.
export const PDF_TEMPLATES = [
  { id: 1, name: "Template 1" },
  { id: 2, name: "Template 2" },
  { id: 3, name: "Template 3" },
  { id: 4, name: "Template 4" },
  { id: 5, name: "Template 5" },
];

export const DEFAULT_PDF_TEMPLATE_ID = 1;

export const pdfTemplateOptions = () =>
  PDF_TEMPLATES.map((t) => ({ value: t.id, label: t.name }));

export const pdfTemplateName = (id) =>
  PDF_TEMPLATES.find((t) => t.id === Number(id))?.name ?? null;
